import { api } from 'shared/api/client';
import { useQuery } from '@tanstack/react-query';
import { documentPermissionKeys } from 'entities/document-permission';

export const usePermissions = (documentSuperId: number | string) => {
  const {
    data,
    isLoading,
    isSuccess,
    refetch: fetchPermissionData,
  } = useQuery({
    queryKey: documentPermissionKeys.forDocument(documentSuperId),

    queryFn: async () => {
      const res = await api.GET('/documents/{superId}/current-user-permissions', {
        params: { path: { superId: Number(documentSuperId) } },
      });
      const { data } = res;
      const sectionDictionary: Record<string, string> = {};
      data?.userSectionPermissions.forEach(
        (permission: { sectionSuperId: string; permission: string }) => (sectionDictionary[permission.sectionSuperId] = permission.permission)
      );
      return { userDocumentPermissions: data?.userDocumentPermissions, sectionPermissions: sectionDictionary ?? {} };
    },

    enabled: !!documentSuperId,
    staleTime: 5 * 60 * 1000,
  });

  return {
    documentPermissions: data?.userDocumentPermissions ?? [],
    sectionPermissions: data?.sectionPermissions ?? {},
    fetchPermissionData,
    isLoading,
    isSuccess,
  };
};
